import { PipesModule } from './pipes/pipes.module';
import { IngredientService } from '@app/services/ingredient/ingredient.service';
import { fullHeightDirective } from './directives/fullHeight';
import { DisableLinkDirective } from './directives/disable-link';
import { MenuService } from './services/menu/menu.service';
import { ProductService } from './services/product/product.service';
import { FamilyService } from './services/family/family.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PdvService } from './services/pdv/pdv.service';
import { OrdersService } from './services/order/orders.service';
import { WebSiteUsersService } from './services/webSiteUsers/webSiteUsers.service';
import { AuthService } from './services/Auth/auth.service';
import { ToastrService } from 'ngx-toastr';
import { HostService } from './services/host/host.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule} from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AddHeaderInterceptor } from './services/AddHeaderInterceptor/AddHeaderInterceptor';
import { mapsService } from './services/maps/maps.service';
import { ModalsModule } from '@app/modules/modals/modals.module';
import { localStorageService } from './services/localStorage/localStorage.service';
import { ConstService } from './services/const/const.service';
import { OurAppComponent } from './modules/common/our-app/our-app.component';
import { FacebookLoginProvider } from './modules/angular-6-social-login-master';
import { AuthServiceConfig } from './modules/angular-6-social-login-master/auth.service';
import { GoogleLoginProvider } from './modules/angular-6-social-login-master';

export function socialConfigs() {  
  const config = new AuthServiceConfig(  
    [  
      {  
        id: FacebookLoginProvider.PROVIDER_ID,  
        provider: new FacebookLoginProvider(PdvService.facebookId)  
      },  
      {  
        id: GoogleLoginProvider.PROVIDER_ID,  
        provider: new GoogleLoginProvider(PdvService.googleId)  
      }  
    ]  
  );  
  return config;  
}  
@NgModule({
  declarations: [
    AppComponent,
    DisableLinkDirective,
    fullHeightDirective,
    // CgvComponent,
    // LegalNoticeComponent
    OurAppComponent
  ],
  imports: [
    HttpClientModule,
    FormsModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      preventDuplicates: true,
      maxOpened: 1,
      autoDismiss:true,
      positionClass:"toast-top-center",
      // disableTimeOut:true
    }),
    ModalModule.forRoot(),
    ModalsModule,
    BrowserModule.withServerTransition({appId: 'my-app'}),
    PipesModule
  ],
  providers: [
    HostService,
     ToastrService,
     AuthService,
    WebSiteUsersService,
    PdvService,
    BsModalRef,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AddHeaderInterceptor,
      multi: true,
    },
    OrdersService,
    FamilyService,
     ProductService,
     MenuService,
    mapsService,
    IngredientService,
    localStorageService,
    ConstService,
    {  
      provide: AuthServiceConfig,  
      useFactory: socialConfigs  
    }  
  ],
  exports : [
    OurAppComponent
  ],
  bootstrap: [AppComponent],
  entryComponents:[
  ]
})
export class AppModule { }
